import { useEffect, useState } from "react";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from "@/components/ui/carousel";
import type { CarouselApi } from "@/components/ui/carousel";

interface FeatureCard {
  image: string;
  title: string;
  description: string;
}

const features: FeatureCard[] = [
  {
    image: "https://i.ibb.co/j84SRhd/data.png",
    title: "Transform data into insights",
    description:
      "Make informed decisions using the power of data analytics and AI. Harness cutting-edge technology to drive your business forward and stay ahead of the competition.",
  },
  {
    image: "https://i.ibb.co/Gc3BFGx/collaborate.png",
    title: "Collaborate seamlessly",
    description:
      "Work together with your team in real-time. Share insights, make decisions, and drive results collectively.",
  },
  {
    image: "https://i.ibb.co/X7TSR0D/secure.png",
    title: "Secure by design",
    description:
      "Your data is protected with enterprise-grade security. Rest easy knowing your information is safe and compliant.",
  },
];

export const AuthCards = () => {
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const [api, setApi] = useState<CarouselApi | null>(null);

  useEffect(() => {
    if (!api) return;

    const interval = setInterval(() => {
      api.scrollNext();
    }, 5000); // Change slide every 5 seconds

    return () => clearInterval(interval);
  }, [api]);

  return (
    <div className="w-full h-full bg-gradient-to-br from-black via-[#1c1c1c] to-black p-12 flex rounded-xl items-center">
      <div className="w-full">
        <div className="max-w-lg mx-auto">
          <Carousel
            opts={{
              align: "start",
              loop: true,
            }}
            className="w-full"
            setApi={(api) => {
              setApi(api);
              api?.on("select", () => {
                setActiveIndex(api.selectedScrollSnap());
              });
            }}
          >
            <CarouselContent>
              {features.map((feature, index: number) => (
                <CarouselItem key={index}>
                  <img
                    src={feature.image}
                    alt={`${feature.title} illustration`}
                    className="w-full h-64 object-contain rounded-lg mb-8"
                  />
                  <div className="text-white text-center">
                    <h2 className="text-3xl font-bold mb-4">{feature.title}</h2>
                    <p className="text-gray-400">{feature.description}</p>
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
          </Carousel>

          <div className="flex justify-center space-x-2 mt-8">
            {features.map((_, index: number) => (
              <button
                key={index}
                onClick={() => api?.scrollTo(index)}
                className={`w-2 h-2 rounded-full transition-colors ${
                  index === activeIndex ? "bg-white" : "bg-white/50"
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
